// generate icons component
// ng g c shared/components/icons/iconName -is --spec false

import { IconMainLogoComponent } from './icon-main-logo/icon-main-logo.component';
import { IconFacebookComponent } from './icon-facebook/icon-facebook.component';
import { IconTwitterComponent } from './icon-twitter/icon-twitter.component';
import { IconInstagramComponent } from './icon-instagram/icon-instagram.component';
import { IconGooglePlusComponent } from './icon-google-plus/icon-google-plus.component';
import { IconUserComponent } from './icon-user/icon-user.component';
import { IconEyeComponent } from './icon-eye/icon-eye.component';
import { IconOverviewComponent } from './icon-overview/icon-overview.component';
import { IconFinancialComponent } from './icon-financial/icon-financial.component';
import { IconStarComponent } from './icon-star/icon-star.component';
import { IconLocationComponent } from './icon-location/icon-location.component';
import { IconOverviewWhiteComponent } from './icon-overview-white/icon-overview-white.component';
import { IconFinancialWhiteComponent } from './icon-financial-white/icon-financial-white.component';
import { IconStarWhiteComponent } from './icon-star-white/icon-star-white.component';
import { IconLocationWhiteComponent } from './icon-location-white/icon-location-white.component';
import { IconLocationCardComponent } from './icon-location-card/icon-location-card.component';
import { IconBusinessCaseComponent } from './icon-business-case/icon-business-case.component';
import { IconGrowthComponent } from './icon-growth/icon-growth.component';
import { IconIncomeComponent } from './icon-income/icon-income.component';
import { IconCapitalComponent } from './icon-capital/icon-capital.component';
import { IconExpenseComponent } from './icon-expense/icon-expense.component';
import { IconPropertyComponent } from './icon-property/icon-property.component';
import { IconVideoComponent } from './icon-video/icon-video.component';
import { IconTimelineComponent } from './icon-timeline/icon-timeline.component';
import { IconBuildingComponent } from './icon-building/icon-building.component';
import { IconBuildingWhiteComponent } from './icon-building-white/icon-building-white.component';
import { IconEyeCloseComponent } from './icon-eye-close/icon-eye-close.component';
import { IconLogoDarkComponent } from './icon-logo-dark/icon-logo-dark.component';
import { IconPinComponent } from './icon-pin/icon-pin.component';
import { IconInfoYellowComponent } from './icon-info-yellow/icon-info-yellow.component';
import { SpinnerLoaderComponent } from './spinner-loader/spinner-loader.component';
import { IconCircleCheckComponent } from './icon-circle-check/icon-circle-check.component';
import { IconResetPasswordComponent } from './icon-reset-password/icon-reset-password.component';
import { IconResetCheckComponent } from './icon-reset-check/icon-reset-check.component';
import { IconWireTransferComponent } from './icon-wire-transfer/icon-wire-transfer.component';
import { IconBankComponent } from './icon-bank/icon-bank.component';
import { IconPlaidLogoComponent } from './icon-plaid-logo/icon-plaid-logo.component';
import { CircularProgressComponent } from './circular-progress/circular-progress.component';
import { IconFilterComponent } from './icon-filter/icon-filter.component';
import { IconHomeComponent } from './icon-home/icon-home.component';
import { IconBedComponent } from './icon-bed/icon-bed.component';
import { IconBathComponent } from './icon-bath/icon-bath.component';
import { IconFireComponent } from './icon-fire/icon-fire.component';
import { IconHourGlassComponent } from './icon-hour-glass/icon-hour-glass.component';
import { IconDashboardComponent } from './icon-dashboard/icon-dashboard.component';
import { IconProfileComponent } from './icon-profile/icon-profile.component';
import { IconLogoutComponent } from './icon-logout/icon-logout.component';
import { IconAssetComponent } from './icon-asset/icon-asset.component';
import { IconIncomeV2Component } from './icon-income-v2/icon-income-v2.component';
import { IconGrowthV2Component } from './icon-growth-v2/icon-growth-v2.component';
import { IconReturnsComponent } from './icon-returns/icon-returns.component';
import { IconPlusCircleComponent } from './icon-plus-circle/icon-plus-circle.component';
import { IconIncomeGrayComponent } from './icon-income-gray/icon-income-gray.component';
import { IconPlusWhiteComponent } from './icon-plus-white/icon-plus-white.component';
import { IconTimeComponent } from './icon-time/icon-time.component';
import { MarketplaceIconComponent } from './marketplace-icon/marketplace-icon.component';
import { InvestorsIconComponent } from './investors-icon/investors-icon.component';
import { OpenIconComponent } from './open-icon/open-icon.component';
import { SaveIconComponent } from './save-icon/save-icon.component';
import { ReceivingIconComponent } from './receiving-icon/receiving-icon.component';
import { BankIconComponent } from './bank-icon/bank-icon.component';
import { InvestorIconComponent } from './investor-icon/investor-icon.component';
import { YieldsIconComponent } from './yields-icon/yields-icon.component';
import { LongTermIconComponent } from './long-term-icon/long-term-icon.component';
import { DiversifyIconComponent } from './diversify-icon/diversify-icon.component';
import { StayingIconComponent } from './staying-icon/staying-icon.component';
import { OwnershipIconComponent } from './ownership-icon/ownership-icon.component';
import { NumberOneIconComponent } from './number-one-icon/number-one-icon.component';
import { NumberTwoIconComponent } from './number-two-icon/number-two-icon.component';
import { BookingIconComponent } from './booking-icon/booking-icon.component';
import { CheckinIconComponent } from './checkin-icon/checkin-icon.component';
import { ListingIconComponent } from './listing-icon/listing-icon.component';
import { OccupancyIconComponent } from './occupancy-icon/occupancy-icon.component';
import { WebLogoIconComponent } from './web-logo-icon/web-logo-icon.component';
import { EmailLogoIconComponent } from './email-logo-icon/email-logo-icon.component';
import { NumberThreeIconComponent } from './number-three-icon/number-three-icon.component';
import { NumberFourIconComponent } from './number-four-icon/number-four-icon.component';
import { AchIconComponent } from './ach-icon/ach-icon.component';
import { KeylobbyIconComponent } from './keylobby-icon/keylobby-icon.component';
import { IconEmailComponent } from './icon-email/icon-email.component';
import { IconAddressComponent } from './icon-address/icon-address.component';
import { IconDocumentComponent } from './icon-document/icon-document.component';
import { IconLinkednComponent } from './icon-linkedn/icon-linkedn.component';
import { IconInfoCircleComponent } from './icon-info-circle/icon-info-circle.component';
import { IconHomeWhiteComponent } from './icon-home-white/icon-home-white.component';
import { IconBedWhiteComponent } from './icon-bed-white/icon-bed-white.component';
import { IconBathWhiteComponent } from './icon-bath-white/icon-bath-white.component';
import { IconIncomeBlueComponent } from './icon-income-blue/icon-income-blue.component';
import { IconInfoWhiteCircleComponent } from './icon-info-white-circle/icon-info-white-circle.component';
import { IconPlusGrayComponent } from './icon-plus-gray/icon-plus-gray.component';
import { IconTrashComponent } from './icon-trash/icon-trash.component';
import { IconNetWorthComponent } from './icon-net-worth/icon-net-worth.component';
import { IconIncomeVerificationComponent } from './icon-income-verification/icon-income-verification.component';
import { IconAccreditedLetterComponent } from './icon-accredited-letter/icon-accredited-letter.component';
import { IconConfirmCheckComponent } from './icon-confirm-check/icon-confirm-check.component';
import { IconSortComponent } from './icon-sort/icon-sort.component';
import { IconEmptyPropertyComponent } from './icon-empty-property/icon-empty-property.component';
import { IconAchGreenComponent } from './icon-ach-green/icon-ach-green.component';
import { IconWireComponent } from './icon-wire/icon-wire.component';
import { IconConfirmWarningComponent } from './icon-confirm-warning/icon-confirm-warning.component';
import { IconAchGrayComponent } from './icon-ach-gray/icon-ach-gray.component';
import { IconWireGreenComponent } from './icon-wire-green/icon-wire-green.component';
import { IconWarningOComponent } from './icon-warning-o/icon-warning-o.component';
import { IconInfoOrangeComponent } from './icon-info-orange/icon-info-orange.component';
import { IconCameraComponent } from './icon-camera/icon-camera.component';
import { IconCameraSmallComponent } from './icon-camera-small/icon-camera-small.component';
import { IconProfileBlackComponent } from './icon-profile-black/icon-profile-black.component';
import { IconProfileWhiteComponent } from './icon-profile-white/icon-profile-white.component';
import { IconSecurityWhiteComponent } from './icon-security-white/icon-security-white.component';
import { IconSecurityBlackComponent } from './icon-security-black/icon-security-black.component';
import { IconEmailConfirmComponent } from './icon-email-confirm/icon-email-confirm.component';
import { IconPendingComponent } from './icon-pending/icon-pending.component';

export const Icons = [
  IconMainLogoComponent,
  IconFacebookComponent,
  IconTwitterComponent,
  IconInstagramComponent,
  IconGooglePlusComponent,
  IconUserComponent,
  IconEyeComponent,
  IconOverviewComponent,
  IconFinancialComponent,
  IconStarComponent,
  IconLocationComponent,
  IconOverviewWhiteComponent,
  IconFinancialWhiteComponent,
  IconStarWhiteComponent,
  IconLocationWhiteComponent,
  IconLocationCardComponent,
  IconBusinessCaseComponent,
  IconGrowthComponent,
  IconIncomeComponent,
  IconCapitalComponent,
  IconExpenseComponent,
  IconPropertyComponent,
  IconVideoComponent,
  IconTimelineComponent,
  IconBuildingComponent,
  IconBuildingWhiteComponent,
  IconEyeCloseComponent,
  IconLogoDarkComponent,
  IconPinComponent,
  IconInfoYellowComponent,
  SpinnerLoaderComponent,
  IconCircleCheckComponent,
  IconResetPasswordComponent,
  IconResetCheckComponent,
  IconWireTransferComponent,
  IconBankComponent,
  IconPlaidLogoComponent,
  CircularProgressComponent,
  IconFilterComponent,
  IconHomeComponent,
  IconBedComponent,
  IconBathComponent,
  IconFireComponent,
  IconHourGlassComponent,
  IconDashboardComponent,
  IconProfileComponent,
  IconLogoutComponent,
  IconAssetComponent,
  IconIncomeV2Component,
  IconGrowthV2Component,
  IconReturnsComponent,
  IconPlusCircleComponent,
  IconIncomeGrayComponent,
  IconPlusWhiteComponent,
  IconTimeComponent,
  MarketplaceIconComponent,
  InvestorsIconComponent,
  OpenIconComponent,
  SaveIconComponent,
  ReceivingIconComponent,
  BankIconComponent,
  InvestorIconComponent,
  YieldsIconComponent,
  LongTermIconComponent,
  DiversifyIconComponent,
  StayingIconComponent,
  OwnershipIconComponent,
  NumberOneIconComponent,
  NumberTwoIconComponent,
  BookingIconComponent,
  CheckinIconComponent,
  ListingIconComponent,
  OccupancyIconComponent,
  WebLogoIconComponent,
  EmailLogoIconComponent,
  NumberThreeIconComponent,
  NumberFourIconComponent,
  AchIconComponent,
  KeylobbyIconComponent,
  IconEmailComponent,
  IconAddressComponent,
  IconDocumentComponent,
  IconLinkednComponent,
  IconInfoCircleComponent,
  IconHomeWhiteComponent,
  IconBedWhiteComponent,
  IconBathWhiteComponent,
  IconIncomeBlueComponent,
  IconInfoWhiteCircleComponent,
  IconPlusGrayComponent,
  IconTrashComponent,
  IconNetWorthComponent,
  IconIncomeVerificationComponent,
  IconAccreditedLetterComponent,
  IconConfirmCheckComponent,
  IconSortComponent,
  IconEmptyPropertyComponent,
  IconAchGreenComponent,
  IconWireComponent,
  IconConfirmWarningComponent,
  IconAchGrayComponent,
  IconWireGreenComponent,
  IconWarningOComponent,
  IconInfoOrangeComponent,
  IconCameraComponent,
  IconCameraSmallComponent,
  IconProfileBlackComponent,
  IconProfileWhiteComponent,
  IconSecurityWhiteComponent,
  IconSecurityBlackComponent,
  IconEmailConfirmComponent,
  IconPendingComponent
];
